export default __webpack_public_path__ + "static/media/title.02e28118.jpg";